/**
* @file 框架-顶部
* @description 已拆分为多个子组件，提高可维护性
* 子组件位于 ./components/ 目录下
* */
<template>
  <div id="frame-header">
    <!-- 左侧Logo和公司名称 -->
    <header-left :organization="organization" />

    <!-- 中间余额信息 -->
    <header-center 
      :sensitive-tips-num="sensitiveTipsNum"
      :sms-count="smsCount"
      :ai-balance="aiBalance"
      @show-sensitive="getSensitiveTipsTable"
      @ai-recharge="AIRechargeClick"
      @sms-recharge="smsRechargeClick"
    />

    <!-- 右侧操作按钮 -->
    <header-right 
      @show-qrcode="showQrcode({ id: mixinUserInfo.organizationId })"
      @app-download="APPdownload"
      @goods-open="goodsOpen"
      @change-password="dialogVisible = true"
    />

    <!-- 导出进度条 -->
    <export-progress :excel-form="excelFormGetter" />
    <!-- 修改密码弹窗 -->
    <el-dialog 
      class="password-dialog" 
      @close="close" 
      :visible.sync="dialogVisible" 
      width="420px" 
      :show-close="false"
      :close-on-click-modal="false"
      append-to-body>
      <div slot="title" class="password-dialog-header">
        <div class="header-icon">
          <i class="el-icon-lock"></i>
        </div>
        <div class="header-text">
          <h3>修改密码</h3>
          <p>请设置新的登录密码</p>
        </div>
        <button class="close-btn" @click="dialogVisible = false">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="password-dialog-content">
        <el-form :model="form" :rules="rules" ref="setform">
          <el-form-item prop="password">
            <el-input 
              name="password" 
              type="password" 
              v-model="form.password" 
              placeholder="请输入新密码"
              prefix-icon="el-icon-lock"
              show-password>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwords">
            <el-input 
              name="passwords" 
              type="password" 
              v-model="form.passwords" 
              placeholder="请确认新密码"
              prefix-icon="el-icon-lock"
              show-password>
            </el-input>
          </el-form-item>
          <div class="password-tips">
            <i class="el-icon-info"></i>
            <span>密码长度6-20位，建议包含字母和数字</span>
          </div>
          <div class="password-actions">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="save">确认修改</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleSensitiveTipsTable" width="1200px" title="敏感人员预警">
      <custom-table v-if="dialogVisibleSensitiveTipsTable" ref="customTable"
        :customOptions="customOptionssensitiveTipsTable" :has-organization="true" :columns="columnsSensitiveTips"
        @refreshFn="sensitiveTipsNum = 0" maxHeight="450" excel-type="SensitivePersonnelAlert">
        <div slot="search-bottom" style="margin-top:10px;color:#999">
          说明：敏感人员的手机号、身份证号被用于下单时，将产生一条行为记录
        </div>
        <template slot-scope="{ item, row }">
          <template v-if="item.prop === 'created'">{{
            row.created | filterTime
          }}
          </template>
          <template v-else>{{
            row[item.prop] ? row[item.prop] : "-"
          }}
          </template>
        </template>
      </custom-table>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleCallCatTable" width="30%" title="电召记录">
      <div style="color: #999; margin-bottom: 1rem">
        只会记录手机号码，座机号不会记录
      </div>
      <el-table :data="callListGetter" border style="width: 100%">
        <el-table-column fixed prop="phone" label="手机号码" min-width="150">
        </el-table-column>
        <el-table-column label="呼入时间" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.time | filterTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button @click="handleCallCatPaOClick(scope.row)" type="text" size="small">下单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-drawer :visible.sync="callCatPaODrawerShow">
      <orderForm v-if="callCatPaODrawerShow" :copyPhone="copyPhone" @callCatPaOSuccess="callCatPaOSuccess" />
    </el-drawer>

    <!-- APP下载弹窗 -->
    <AppDownloadDialog 
      v-model="qrcodeVisible" 
      :qrcodeText="qrcodeText" 
    />

    <!-- 司机注册二维码弹窗 -->
    <DriverRegisterDialog 
      v-model="show" 
      :qrcodeUrl="qrcodeUrl" 
      :qrcodeText="qrcodeText" 
    />


    <aliPayDialog ref="aliPayDialog" @success="paySuccess"></aliPayDialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueQr from "vue-qr";
import orderForm from "@/page/orderForm/orderForm.vue";
import { download } from '@/assets/js/domToImgAndDownloadZip';
import aliPayDialog from "@/components/aliPayDialog";
// 子组件导入
import HeaderLeft from './components/HeaderLeft.vue';
import HeaderCenter from './components/HeaderCenter.vue';
import HeaderRight from './components/HeaderRight.vue';
import ExportProgress from './components/ExportProgress.vue';
import AppDownloadDialog from './components/AppDownloadDialog.vue';
import DriverRegisterDialog from './components/DriverRegisterDialog.vue';
// 外部链接配置
import externalLinks, { getManualUrl, getRechargeUrl } from '@/assets/json/externalLinks';

export default {
  name: "frame-header",

  components: { 
    VueQr, 
    orderForm, 
    aliPayDialog,
    HeaderLeft,
    HeaderCenter,
    HeaderRight,
    ExportProgress,
    AppDownloadDialog,
    DriverRegisterDialog
  },
  computed: {
    ...mapGetters({
      messageGetter: "messageGetter",
      excelFormGetter: "excelFormGetter",
      callNumGetter: "callNumGetter",
      callListGetter: "callListGetter",
    }),
  },
  watch: {
    messageGetter(val) {
      switch (val.msg) {
        case "OrganizationBalance": // 组织机构余额变化
          if (Number(this.mixinUserInfo.organizationId) === Number(val.data)) {
            this.getSmsCount();
          }
          break;
        case "OrganizationSMSBalance": // 组织机构余额变化
          this.getSmsCount();
          break;
        case "OrganizationAIBalance": // 组织机构余额变化
          this.getAIBalance();
          break;
        case "EditOrganization": // 组织机构变化
          if (Number(this.mixinUserInfo.organizationId) === Number(val.data)) {
            this.getOrganization();
          }
          break;
        case "SensitivePersonnelAler": // 敏感人员预警
          this.getSensitiveTipsNum();
          break;
      }
    },
    callNumGetter(val) {
      if (this.dialogVisibleCallCatTable) {
        let time = new Date().getTime();
        sessionStorage.setItem("lastCallTime", time);
        this.$store.commit("callNum_U", 0);

      }
    },
  },
  data() {
    let validateCheck = (rule, value, callback) => {
      if (!this.id) {
        if (!value && value !== 0) {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.form.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      } else {
        if (value !== this.form.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      }
    };
    return {
      bg: require("@/assets/img/download_register.png"),
      bg1: require("@/assets/img/flow_chart.png"),
      show: false,
      qrcodeUrl: '',
      defaultActive: sessionStorage.getItem("menuActiveUrl"),
      form: {
        password: "",
        passwords: "",
      },
      dialogVisible: false,
      dialogVisibleSensitiveTipsTable: false,
      customOptionssensitiveTipsTable: {
        showLabel: false,
        // 请求的列表url
        url: "/api/v1/manage/sensitive/personnel/alert",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "idCard",
            name: "身份证号码",
            value: "",
          },
          {
            type: "input",
            field: "phone",
            name: "手机号码",
            value: "",
          },
          {
            type: "datetime",
            field: "Time",
            name: "下单时间",
            value: [],
          },
        ],
      },
      columnsSensitiveTips: [
        { prop: "idCard", label: "身份证号码", width: 170 },
        { prop: "phone", label: "手机号码", width: 120 },
        { prop: "behaviorRecord", label: "行为记录" },
        { prop: "created", label: "下单时间", width: 150 },
      ],
      sensitiveTipsTable: [],
      dialogVisibleCallCatTable: false,
      copyPhone: null,
      copyTime: null,
      callCatPaODrawerShow: false,
      permissions1: false,
      // 平台信息
      info: {},
      sensitiveTipsNum: 0, // 敏感人员提醒
      // AI识别条数
      aiBalance: {},
      // 剩余短信条数
      smsCount: {},
      organization: {},
      // 短信充值按钮
      loading: false,
      permissions: "",
      rules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { pattern: /^[\w]{6,12}$/, message: "请输入6-12的位密码" },
        ],
        passwords: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: validateCheck },
        ],
      },
      // 查看二维码
      qrcodeVisible: false,
      qrcodeText: '',
      // popover 显示控制
      orderAmountVisible: false,
      aiBalanceVisible: false,
      smsCountVisible: false,
    };
  },
  methods: {
    helpFn(val) {
      if (val == "used") {
        this.getUrl();
      } else {
        this.viewUpdateLogs()
      }
    },
    paySuccess() {
      this.getAIBalance();
    },
    downloadAppPath2() {
      // let oQrcode = document.getElementsByClassName("qr-code-down2")[0];
      // let a = document.createElement("a");
      // a.href = oQrcode.src;
      // a.download = "司机注册二维码";
      // a.click();
      this.$nextTick(() => {
        download(document.querySelectorAll(".download_material_down"), ["司机注册二维码", "司机注册物料图", "司机认证物料图"]);
      });
    },
    async showQrcode(row) {
      const url = "/api/v1/manage/organization/qrcode/" + row.id;
      const { data, code } = await this.$axios.get(url);
      if (data && code === 1) {
        this.qrcodeUrl = `${data.url}/#/register?organizationId=${data.organizationId}&appKey=${data.appKey}&appPath=${data.appPath}`
        this.show = true
      }
    },
    goHomeFn() {
      if (this.defaultActive) {
        this.$router.push(this.defaultActive)
      } else {
        this.$router.go(-1)
      }
    },
    /* 处理电召订单 start */
    getCallCatTable() {
      let time = new Date().getTime();
      sessionStorage.setItem("lastCallTime", time);
      this.$store.commit("callNum_U", 0);
      this.dialogVisibleCallCatTable = true;
    },
    handleCallCatPaOClick(item) {
      this.copyPhone = item.phone;
      this.copyTime = item.time;
      this.callCatPaODrawerShow = true;
      var tag = document.createElement("input");
      tag.setAttribute("id", "cp_hgz_input");
      tag.value = item.phone;
      document.getElementsByTagName("body")[0].appendChild(tag);
      document.getElementById("cp_hgz_input").select();
      document.execCommand("copy");
      document.getElementById("cp_hgz_input").remove();
      this.$message.success("号码已复制，按ctrl+v可粘贴");
    },
    callCatPaOSuccess() {
      this.callCatPaODrawerShow = false;
      this.$store.commit("WS_deleteData", this.copyTime);
    },
    /* 处理电召订单 end */
    close() {
      this.$refs.setform.resetFields();
    },
    save() {
      this.$refs.setform.validate((valid) => {
        if (valid) {
          let params = {};
          params.id = Number(JSON.parse(sessionStorage.getItem("userInfo")).id);
          // params.password = this.form.password
          params.password = this.$utils.sha256Fn(this.form.password);

          this.updatePassword(params);
        } else {
          return false;
        }
      });
    },
    async updatePassword(params) {
      let url = "/api/v1/manage/admin/updatePassword";
      let data = await this.$axios.post(url, params);

      if (data && data.code === 1) {
        this.$message.success("密码修改成功");
        this.dialogVisible = false;
        this.$refs.setform.resetFields();
      }
    },
    /* 点击跳转使用手册页面 */
    getUrl() {
      const url = getManualUrl(this.mixinUserInfo.platformType);
      window.open(url);
    },
    async getAppDownload() {
      let url = "/api/v1/manage/appPath";
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data.driverPath) {
        this.qrcodeText = data.data.driverPath;
      }
    },
    /* APP下载二维码 */
    async APPdownload() {
      let url = "/api/v1/manage/appPath";
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data.driverPath) {
        this.qrcodeVisible = true;
        this.qrcodeText = data.data.driverPath;
      } else {
        this.$message.info("未配置下载链接，请联系工作人员");
      }
    },
    /* 复制并打开链接 */
    copyAndOpenAppPath() {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', this.qrcodeText);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success("链接已复制");
      } else {
        this.$message.info("该浏览器不支持复制，请手动复制地址栏链接");
      }
      document.body.removeChild(input);

      setTimeout(() => {
        window.open(this.qrcodeText)
      }, 500);
    },
    /* 下载二维码图片 */
    downloadAppPath() {
      let oQrcode = document.getElementsByClassName("qr-code-down")[0];
      let a = document.createElement("a");
      a.href = oQrcode.src;
      a.download = "司机端APP下载二维码";
      a.click();
    },
    async getOrganization() {
      let url =
        "/api/v1/common/organization/" + this.mixinUserInfo.organizationId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.organization = data.data;
      }
    },
    async getProgress() {
      let url = "/api/v1/common/excel/progress";
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data) {
        this.$store.dispatch("acExcelForm", data.data);
      }
    },
    /* 退出登录 */
    logout(e) {
      if (e == "退出登录") {
        this.$store.dispatch("acLogout");
      } else {
        this.dialogVisible = true;
      }
    },
    /* 获取系统logo和name */
    async getSystemInfo() {
      let url = "/api/v1/common/title";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.info = data.data;
      }
    },
    /* 第三方AI识别token */
    async getAIToken() {
      let url = "/api/v1/manage/ai/token";
      let res = await this.$axios.get(url);
      if (res && res.code === 1) {
        return res.data;
      }
    },
    /* 第三方AI识别充值 */
    async AIRechargeClick() {
      this.$refs.aliPayDialog.rechargeOpen('AI_FEE', this.aiBalance.aiSettleConfig === 2 ? this.mixinUserInfo.organizationId : null);
      // this.loading = true;
      // let token = await this.getAIToken();
      // let url =
      //     `https://manage.rvaka.com/#/recharge?companyId=${this.mixinUserInfo.organizationId}&rechargeSource=passengerTransport&type=busAi&authorization=${token}`;
      // window.open(url);
      // this.loading = false;
    },
    /* 短信充值 */
    async smsRechargeClick() {
      this.loading = true;
      let token = await this.getSmsToken();
      const url = getRechargeUrl('sms', this.mixinUserInfo.organizationId, token);
      window.open(url);
      this.loading = false;
    },
    /* 更新日志 */
    async viewUpdateLogs() {
      window.open(externalLinks.changelog);
      this.loading = false;
    },
    /* 平台代下单 */
    async orderFormOpen() {
      this.$router.push(this.mixinUserInfo.platformType == 1 ? '/orderForm' : '/orderFormByChannel3')
    },
    wlCreartOrder(command) {
      this[command]()
    },
    /* 散客下单 */
    async fitOpen() {
      window.open('/#/fitOrder')
    },
    /* 文旅商品 */
    async goodsOpen() {
      window.open('/#/travelReservation')
    },
    /* 敏感人员预警数量 */
    async getSensitiveTipsNum() {
      let url = "/api/v1/manage/sensitive/personnel/alert/count";
      let data = await this.$axios.get(url, { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.sensitiveTipsNum = data.data || 0;
      }
    },
    /* 敏感人员预警列表 */
    async getSensitiveTipsTable() {
      this.dialogVisibleSensitiveTipsTable = true;
      this.$nextTick(() => {
        this.$refs.customTable.listFn();
        this.sensitiveTipsNum = 0;
      });
    },
    /* 短信token */
    async getSmsToken() {
      let url = "/api/v1/manage/sms/token";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        return data.data;
      }
    },
    /* 短信剩余条数*/
    async getSmsCount() {
      let url = "/api/v1/manage/sms/count";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.smsCount = data.data || {};
      }
    },
    async getAIBalance() {
      let url = "/api/v1/manage/ai/count";
      let res = await this.$axios.get(url);
      if (res && res.code === 1) {
        this.aiBalance = res.data;
      }
    },
  },
  created() {
    this.$store.commit("WS_connect"); // 连接电话猫
    this.getSensitiveTipsNum();
    this.getOrganization();
    this.getSmsCount();
    this.getAIBalance();
    this.getAppDownload();
  }
};
</script>

<style lang="less">
.popover {
  padding: 0 !important;
  border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08) !important;

  .popover-content {
    width: 350px;
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    text-align: left;
    color: #333333;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #409EFF 0%, #66B1FF 100%);
    }

    &-bg {
      width: 80px;
      height: 80px;
      position: absolute;
      right: -10px;
      bottom: -10px;
      z-index: 0;
      opacity: 0.15;
    }

    &-title {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 15px;
      color: #303133;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;

      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        padding: 4px;
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f1ff 100%);
        border-radius: 8px;
      }
    }

    &-detail {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-num {
        font-weight: 600;
        font-size: 14px;
        line-height: 1.4;
        color: #606266;

        span {
          font-size: 28px;
          font-weight: 700;
          color: #409EFF;
          margin-right: 2px;
        }
      }

      &-text {
        font-size: 13px;
        color: #909399;
        padding: 4px 10px;
        background: #f5f7fa;
        border-radius: 12px;
      }

      &-btn {
        padding: 8px 20px;
        background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
        border-radius: 20px;
        font-weight: 500;
        font-size: 13px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
        }
      }
    }
  }
}


/* 
 * 框架头部样式
 * 注意：子组件样式已移至各自组件中（scoped）
 * 此处只保留父容器样式和全局样式（如popover）
 */
#frame-header {

  * {
    white-space: nowrap;
  }

  background: linear-gradient(90deg, #1d1e23, #3f4045);
  color: rgba(255, 255, 255, 0.7);
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;



  /* 司机注册二维码物料下载（隐藏在屏幕外用于截图下载） */
  .download_material {
    width: 750px;
    height: 1620px;
    position: fixed;
    top: 9999px;
    left: 9999px;
    z-index: -1;

    .bg {
      width: 750px;
      height: 1620px;
    }

    .download_material_code {
      position: absolute;
      top: 533px;
      left: 226px;
    }
  }

  .download_material1 {
    width: 750px;
    height: 7030px;
    position: relative;
    position: fixed;
    top: 9999px;
    left: 9999px;
    z-index: -1;

    .download_material_code {
      position: absolute;
      top: 564px;
      left: 236px;
    }

    .download_material_code1 {
      position: absolute;
      bottom: 306px;
      left: 200px;
    }
  }
}

/* 修改密码弹窗样式 */
.password-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
  
  .el-dialog__header {
    padding: 0;
    margin: 0;
  }
  
  .el-dialog__body {
    padding: 0;
  }
  
  .password-dialog-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #409EFF 0%, #2b77ff 100%);
    color: #fff;
    position: relative;
    
    .header-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      
      i {
        font-size: 24px;
      }
    }
    
    .header-text {
      flex: 1;
      
      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
      }
      
      p {
        margin: 4px 0 0;
        font-size: 13px;
        opacity: 0.9;
      }
    }
    
    .close-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
      }
      
      i {
        font-size: 16px;
      }
    }
  }
  
  .password-dialog-content {
    padding: 24px;
    
    .el-form-item {
      margin-bottom: 20px;
      
      .el-input__inner {
        height: 44px;
        border-radius: 8px;
        padding-left: 40px;
      }
      
      .el-input__prefix {
        left: 12px;
        
        i {
          font-size: 18px;
          color: #909399;
        }
      }
    }
    
    .password-tips {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      background: #f0f7ff;
      border-radius: 8px;
      margin-bottom: 20px;
      
      i {
        color: #409EFF;
        margin-right: 8px;
      }
      
      span {
        font-size: 13px;
        color: #666;
      }
    }
    
    .password-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      
      .el-button {
        min-width: 100px;
        height: 40px;
        border-radius: 8px;
        font-weight: 500;
      }
    }
  }
}
</style>
